export default {
  // Navbar
  nav_home: 'Startseite',
  nav_shopping_guide: 'Einkaufsführer',
  nav_spreadsheet: 'Spreadsheet',
  nav_finds: 'Finds',
  nav_categories: 'Kategorien',
  nav_guides: 'Guides',
  nav_shipping: 'Versand',
  nav_qc: 'QC',
  nav_reviews: 'Bewertungen',
  nav_safety: 'Sicherheit',
  nav_explore: 'Spreadsheet Entdecken',

  // Hero
  hero_h1: 'CSSBuy Spreadsheet: Produkte Finden, Optionen Vergleichen & Sicherer Kaufen',
  hero_subtitle: 'Finde Produkte, Links, Listen, Kaufanleitungen, QC-Informationen, Versandkosten und Sicherheitstipps in einer unabhängigen Ressource über CSSBuy Spreadsheet.',
  hero_cta_primary: 'CSSBuy Spreadsheet Entdecken',
  hero_cta_secondary: 'Produkte & Finds Ansehen',
  hero_trust_1: 'Unabhängige Ressource',
  hero_trust_2: 'Aktuelle Guides',
  hero_trust_3: 'Produktsuche',
  hero_trust_4: 'Sicherheitstipps',
  hero_search_placeholder: 'Produkte, Kategorien, Verkäufer oder Keywords suchen...',
  hero_search_button: 'Suchen',

  // What is section
  whatis_h2: 'Was ist ein CSSBuy Spreadsheet?',
  whatis_copy: 'Ein CSSBuy Spreadsheet ist eine praktische Methode, um Produkte, Links, Kategorien, Verkäufer und nützliche Informationen vor einem Kauf zu organisieren. Unser Ziel ist es, relevante Informationen in einer einfachen Struktur zusammenzufassen, um dir zu helfen, Optionen zu vergleichen, den Prozess zu verstehen und fundiertere Entscheidungen zu treffen.',

  // Categories
  categories_h2: 'Beliebte Kategorien Entdecken',
  categories_cta: 'Alle Kategorien Ansehen',
  cat_shoes: 'Schuhe',
  cat_hoodies: 'Hoodies',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jacken',
  cat_pants: 'Hosen',
  cat_bags: 'Taschen',
  cat_accessories: 'Accessoires',
  cat_sportswear: 'Sportswear',
  cat_streetwear: 'Streetwear',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Unterwäsche',
  cat_jersey: 'Jersey',
  cat_belts: 'Gürtel',
  cat_perfumes: 'Parfums',
  cat_other: 'Sonstiges',

  // Finds
  finds_h2: 'Neueste CSSBuy Finds',
  finds_sub: 'Entdecke beliebte Produkte und Ressourcen, organisiert zur Vereinfachung deiner Recherche.',
  finds_table_product: 'Produkt',
  finds_table_category: 'Kategorie',
  finds_table_source: 'Quelle',
  finds_table_info: 'Information',
  finds_table_updated: 'Aktualisiert',
  finds_table_view: 'Ansehen',
  finds_cta: 'Alle Finds Entdecken',

  // Guides
  guides_h2: 'Meistgesuchte CSSBuy Guides',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_qc: 'CSSBuy QC',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_coupon: 'CSSBuy Coupon',
  guide_discount: 'CSSBuy Discount Code',

  // Comparison
  comparison_h2: 'CSSBuy mit Anderen Plattformen Vergleichen',

  // Safety
  safety_h2: 'CSSBuy Safety Center',
  safety_copy: 'Lerne, Links zu überprüfen, Verkäufer zu analysieren, QC-Fotos zu verstehen, deine Daten zu schützen, gefälschte Seiten zu erkennen und mögliche Risiken vor einer Bestellung zu bewerten.',
  safety_cta: 'Safety Center Besuchen',

  // Final CTA
  final_cta_h2: 'Bereit, dein nächstes CSSBuy Spreadsheet zu finden?',
  final_cta_primary: 'CSSBuy Spreadsheet Entdecken',
  final_cta_secondary: 'Hauptseite Besuchen',

  // Disclaimer
  disclaimer: 'Dies ist eine unabhängige Informationsressource und nicht mit CSSBuy verbunden. Überprüfe immer Preise, Versandkosten, Richtlinien, Verkäufer und aktuelle Informationen auf der offiziellen Plattform, bevor du einen Kauf tätigst.',

  // Footer
  footer_resources: 'Ressourcen',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_finds: 'Finds',
  footer_categories: 'Kategorien',
  footer_guides: 'Guides',
  footer_shipping: 'Shipping',
  footer_qc: 'QC',
  footer_reviews: 'Reviews',
  footer_comparisons: 'Comparisons',
  footer_safety: 'Safety',
  footer_company: 'Unternehmen',
  footer_about: 'Über Uns',
  footer_contact: 'Kontakt',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Nutzungsbedingungen',
  footer_disclaimer: 'Disclaimer',
  footer_editorial: 'Editorial Policy',
  footer_language: 'Sprache',
  footer_lang_pt: 'Português',
  footer_lang_de: 'Deutsch',
  footer_lang_en: 'English',
  footer_copyright: '© 2026 CSSBuy Spreadsheet Resource. Unabhängige Ressource.',
  footer_main_site: 'Hauptseite',

  // Article page
  article_breadcrumb_home: 'Startseite',
  article_breadcrumb_guides: 'Guides',
  article_reading_time: 'Min. Lesezeit',
  article_author: 'CSSBuy Spreadsheet Redaktion',
  article_published: 'Veröffentlicht',
  article_updated: 'Aktualisiert',
  article_toc: 'Inhalt',
  article_faq: 'Häufige Fragen',
  article_related: 'Lesen Sie Auch',
  article_cta: 'Mehr im CSSBuy Spreadsheet Entdecken',
  article_back_to_home: 'Zurück zur Startseite',

  // 404
  notfound_title: 'Seite Nicht Gefunden',
  notfound_desc: 'Die gesuchte Seite existiert nicht. Kehre zur Startseite zurück und entdecke weiter.',
  notfound_back: 'Zurück zur Startseite',

  // Meta
  meta_title_home: 'CSSBuy Spreadsheet 2026: Finds, Links & Complete Guide | Unabhängige Ressource',
  meta_desc_home: 'Unabhängige Ressource über CSSBuy Spreadsheet. Finde Produkte, Kaufanleitungen, Versandkosten, QC, Coupons und Sicherheitstipps.',
  meta_title_article: 'CSSBuy Spreadsheet Complete Guide 2026: Verwendung, Produkte Finden & Sicher Kaufen',
  meta_desc_article: 'Vollständiger und unabhängiger Guide über CSSBuy Spreadsheet. Lerne, wie du Produkte organisierst, Links überprüfst, Verkäufer recherchierst und sicherere Kaufentscheidungen triffst.',

  // Buttons to main site
  btn_main_site: 'CSSBuy Spreadsheet',
  btn_buy_now: 'Buy It Now',
  btn_visit_main: 'Hauptseite Besuchen',

  // Category dropdown
  dropdown_label: 'Kategorien',
  dropdown_all: 'Alle Kategorien',

  // Misc
  loading: 'Wird geladen...',
  search: 'Suchen',
  close: 'Schließen',
  read_more: 'Mehr lesen',
  view_all: 'Alle ansehen',
  updated: 'Aktualisiert',
  independent_resource: 'Unabhängige Ressource',
};